import { defineStore } from 'pinia';
import { useSyncs } from '@/lib/syncs';

export const useSyncStore = defineStore('sync', () => {
    const { syncData, fetchLatestSync, initialize, runSyncLegs, runSyncLeg } = useSyncs();

    // Initialize the sync logic
    initialize();

    return {
        syncData,
        fetchLatestSync,
        runSyncLegs,
        runSyncLeg
    };
});